/*
  Tavellio: pre-order label in de productgrids van Boost AI Search & Filter.
  Boost tekent de collectiegrid zelf (niet het thema), daarom staat deze regel hier.

  Regel: product heeft tag "preorder" (gezet door sync-preorder-tags.py vanuit de
  STOQ-export) EN geen leverbare voorraad in het magazijn Mijdrecht
  -> label "Pre-order" in plaats van "Uitverkoop". Anders doet Boost wat het al deed.

  De tekst komt uit het thema (snippets/head.liquid -> window.theme.strings.preOrderBadge,
  gevuld uit locales/*.json), dus per taal en zonder hardcoded tekst.
*/
(function () {
  if (window.__tavellioPreorderLabel) return; // niet dubbel registreren
  window.__tavellioPreorderLabel = true;

  // Welke voorraadlocaties leveren aan welk land? Volgt de Shopify-verzendprofielen (12-09-2026):
  // Mijdrecht levert aan Europa, VK, Australië, Canada; BestFulfillment China levert aan de VS en Canada.
  // Zo kijkt Boost naar dezelfde voorraad als Shopify zelf (variant.inventory_quantity per markt in Liquid).
  var MIJDRECHT = '88782111066';
  var CHINA = ['115872727386', '116236091738']; // BESTFULFILL Service (hier staat de voorraad) en BestFulfillment - China
  // AU wordt net als de VS vanuit China geleverd (besluit eigenaar 17-09-2026)
  var LOCATIONS_BY_COUNTRY = { US: CHINA, CA: [MIJDRECHT].concat(CHINA), AU: CHINA };

  function locationsForCurrentCountry() {
    var cc = (window.Shopify && window.Shopify.country) || '';
    return LOCATIONS_BY_COUNTRY[cc] || [MIJDRECHT];
  }

  function deliverableQty(v, locations) {
    var iq = v.inventory_quantities;
    if (!iq) return typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0;
    var sum = 0, found = false;
    locations.forEach(function (id) {
      if (typeof iq[id] === 'number') { sum += iq[id]; found = true; }
    });
    return found ? sum : (typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0);
  }

  function isPreorder(product) {
    if (!product || !Array.isArray(product.tags) || product.tags.indexOf('preorder') === -1) return false;
    var variants = product.variants || [];
    if (!variants.length) return false;
    var locations = locationsForCurrentCountry();
    return variants.every(function (v) { return deliverableQty(v, locations) <= 0; });
  }
  window.__tavellioPreorderCheck = isPreorder; // alleen voor controle in de console

  function strings() { return (window.theme && window.theme.strings) || {}; }
  function labelText() { return strings().preOrderBadge || strings().preOrder || 'Pre-order'; }
  function soldOutText() { return strings().soldOut || 'Sold out'; }

  // Regel (b): niet leverbaar en geen pre-order -> "Uitverkocht", nooit "Uitverkoop".
  function isSoldOut(product) {
    return !!product && product.available === false;
  }

  window.__BoostCustomization__ = (window.__BoostCustomization__ || []).concat([
    function (registry) {
      registry.useComponentPlugin('ProductLabel', {
        name: 'Tavellio pre-order label',
        enabled: true,
        apply: function () {
          return {
            render: function (elementModel, current) {
              try {
                var e = elementModel;
                while (e && e.name !== 'ProductItem') e = e.getParentElm();
                var product = e && e.getParams().props.product;
                if (!current || !current.props) return current;
                var props;
                if (isPreorder(product)) {
                  props = Object.assign({}, current.props, {
                    labelType: 'preorder',
                    displayType: 'text',
                    labelText: labelText(),
                    color: 'var(--COLOR-PREORDER-TEXT)',
                    backgroundColor: 'var(--COLOR-PREORDER-BG)'
                  });
                } else if (isSoldOut(product)) {
                  props = Object.assign({}, current.props, {
                    labelType: 'soldout',
                    displayType: 'text',
                    labelText: soldOutText()
                  });
                } else {
                  return current;
                }
                return Object.assign({}, current, { props: props });
              } catch (err) {
                return current;
              }
            }
          };
        }
      });
    }
  ]);
})();
